import { render, staticRenderFns } from "./RatingLabels.vue?vue&type=template&id=669e2184&scoped=true&"
import script from "./RatingLabels.vue?vue&type=script&lang=js&"
export * from "./RatingLabels.vue?vue&type=script&lang=js&"
import style0 from "./RatingLabels.vue?vue&type=style&index=0&id=669e2184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e2184",
  null
  
)

export default component.exports